import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as router from '@attain-apps/fe/web/main/lib/router'

import * as me from '../../me'
import * as routeBound from '../../route-bound'

import { Api } from './api.service'
import * as plugins from './plugins'
import type { TypeParams } from './types'

/** Reports collection for the space app */
@ngCore.Injectable()
export class Collection extends ec.Collection<TypeParams> {
  /** @see {@link router.Router} */
  private readonly _router = ngCore.inject(router.Router)

  constructor() {
    const meFeature = ngCore.inject(me.Feature)

    super({
      api: ngCore.inject(Api),
      context$: ngCore.inject(routeBound.scenario.Context.TOKEN),
      identify: report => report.id,
      name: ec.Name.Predefined.SpaceReport,
      plugins: {
        additionalFactories: [
          new plugins.accountDimensionFilter.Factory(),
          new plugins.clusterDimensionFilter.Factory(),
          new plugins.organizationDimensionFilter.Factory(),
          new plugins.employeeDimensionFilter.Factory(),
          new plugins.roomTypeDimensionFilter.Factory(),
          new plugins.spaceDimensionFilter.Factory(),
          new plugins.configuration.Factory(),
          new plugins.download.Factory(),
          new ds.table.ec.Factory<TypeParams>(() => ({
            rowConfig: ({ entity }) => ({
              onClick: () => {
                const source = `Reports.Table.Row-${entity.id}.Clicked`

                this.plugins.currentEntityPlugin.storage.actions.putInIdLookup
                  .from(source)
                  .dispatch({ value: entity.id })

                const url = meFeature.contexts.selectors
                  .getUrlForLink({
                    goto: {
                      navigationId: ents.extra.prebuilt.Page.Id.SpaceReport,
                    },
                  })
                  .asSignal()

                if (url) {
                  this._router.actions.navigate.from(source).dispatch({ url })
                }
              },
            }),
            search: true,
          })),
        ],
      },
    })
  }
}
